
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Download, FileText, Link } from 'lucide-react';

const ResourcesTab = () => {
  const resources = [
    {
      id: '1',
      title: 'Sales Process Guide',
      description: 'Complete guide to our sales methodology',
      type: 'PDF',
      downloadUrl: '#',
    },
    {
      id: '2',
      title: 'Objection Handling Scripts',
      description: 'Ready-to-use scripts for common objections',
      type: 'PDF',
      downloadUrl: '#',
    },
    {
      id: '3',
      title: 'Product Feature Comparison',
      description: 'Detailed comparison sheet for all products',
      type: 'Excel',
      downloadUrl: '#',
    },
    {
      id: '4',
      title: 'Customer Persona Templates',
      description: 'Templates for identifying and targeting customers',
      type: 'PDF',
      downloadUrl: '#',
    },
  ];

  const handleDownload = (url: string, title: string) => {
    // For now, just log the action - you can replace with actual download logic
    console.log(`Downloading: ${title} from ${url}`);
  };

  return (
    <div className="grid gap-6">
      <div className="mb-4">
        <h2 className="text-2xl font-semibold mb-2">Training Resources</h2>
        <p className="text-gray-600">Download helpful materials to support your sales training</p>
      </div>
      
      <div className="grid gap-4">
        {resources.map((resource) => (
          <Card key={resource.id} className="hover:shadow-md transition-shadow">
            <CardContent className="p-6">
              <div className="flex items-start justify-between">
                <div className="flex items-start gap-4">
                  <div className="p-2 bg-blue-100 rounded-lg">
                    <FileText className="h-6 w-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-1">{resource.title}</h3>
                    <p className="text-gray-600 mb-2">{resource.description}</p>
                    <span className="inline-flex items-center px-2 py-1 bg-gray-100 text-gray-700 rounded text-sm">
                      {resource.type}
                    </span>
                  </div>
                </div>
                <Button
                  onClick={() => handleDownload(resource.downloadUrl, resource.title)}
                  className="flex items-center gap-2"
                >
                  <Download className="h-4 w-4" />
                  Download
                </Button>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default ResourcesTab;
